import React, {useEffect} from 'react'
import {useDispatch} from 'react-redux'

import {trackAccommodationPageSelectedDealMRP} from '@vio/core/src/_web/utils/analytics/trackPerformanceMetrics'
import {RoomCardEntity, RoomCardEntityType} from '@vio/core/src/room/types/room'

import {SplitBookingCard} from '../SplitBookingCard/SplitBookingCard'
import {RoomCard} from '.'

export type Props = {
  hotelId: string
  entity: RoomCardEntity
  isCheapest: boolean
  totalResults: number
}

export const RoomOrSplitBooking = ({
  hotelId,
  entity,
  isCheapest,
  totalResults
}: Props) => {
  const dispatch = useDispatch()

  // Tracking selected offer render performance
  useEffect(() => {
    if (
      entity.type === RoomCardEntityType.Regular &&
      entity.data.hasClickedOffer
    ) {
      trackAccommodationPageSelectedDealMRP(dispatch)
    } else if (
      entity.type === RoomCardEntityType.SplitBooking &&
      entity.data.isClicked
    ) {
      trackAccommodationPageSelectedDealMRP(dispatch)
    }
  }, [dispatch, entity])

  if (entity.type === RoomCardEntityType.Regular) {
    const room = entity.data
    return <RoomCard key={room.id} hotelId={hotelId} room={room} />
  }
  if (entity.type === RoomCardEntityType.SplitBooking) {
    const splitBooking = entity.data
    return (
      <SplitBookingCard
        key={entity.id}
        splitBooking={splitBooking}
        isCheapest={isCheapest}
        isOnlySplitBookingOfferAvailable={totalResults === 1}
      />
    )
  }
}
